import { render, staticRenderFns } from "./ScoreTag.vue?vue&type=template&id=60c37fc8&scoped=true&"
import script from "./ScoreTag.vue?vue&type=script&lang=js&"
export * from "./ScoreTag.vue?vue&type=script&lang=js&"
import style0 from "./ScoreTag.vue?vue&type=style&index=0&id=60c37fc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c37fc8",
  null
  
)

export default component.exports